<template>
  <div class="business-person">
    <common-layout>
      <div slot="header">
        <h3>往期人员名单</h3>
      </div>
      <div slot="container">
        <div class="business-person.header">
          <el-button class="business-person.addBtn" @click="$router.go(-1)">返回上一页</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623AA2; border: none;"
          >
            新增
          </el-button>
          <section>
            <el-input
              style="margin-right:10px;"
              placeholder="请输入用户姓名"
              v-model="searchValue"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <label style="margin-right: 10px; line-height: 40px; min-width: 60px">发布平台:</label>
            <el-select
              style="width: 300px"
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="search"
            >
            <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
            <!-- <el-button type="warning" class="active-detail.addBtn" @click="importExcel">导入</el-button> -->
          </section>
        </div>
        <div class="active-detail.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="序号" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="180" align="center"></el-table-column>
            <el-table-column
              prop="certificate"
              label="证书编号"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="courseName"
              label="级别"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column prop="coursePhase" label="培训期数" align="center"></el-table-column>
            <el-table-column
              prop="learnDuration"
              label="完成学时"
              align="center"
            ></el-table-column>
            <el-table-column prop="area" label="所属区域" align="center"></el-table-column>
            <el-table-column prop="isGraduated" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag type="success" v-show="scope.row.isGraduated == 1">已毕业</el-tag>
                <el-tag type="danger" v-show="scope.row.isGraduated == 2">未毕业</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发布平台" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="往期人员名单"
      :visible.sync="dialogVis"
      width="30%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="form">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="证书编号" prop="certificate">
          <el-input
            v-model="form.certificate"
            autocomplete="off"
            placeholder="请填写证书编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card">
          <el-input v-model="form.card" autocomplete="off" placeholder="请填写身份证号"></el-input>
        </el-form-item>
        <el-form-item label="级别" prop="course_id">
          <el-select
            v-model="form.course_id"
            style="width: 100%;"
            　clearable
            placeholder="请选择级别"
            @change="courseIdChange"
          >
            <el-option label="初级" :value="1"></el-option>
            <el-option label="中级" :value="2"></el-option>
            <el-option label="高级" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训期数" prop="course_phase">
          <el-input
            v-model="form.course_phase"
            placeholder="请填写培训期数"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="总课时" prop="course_total">
          <el-input v-model="form.course_total" disabled type="number"></el-input>
        </el-form-item>
        <el-form-item label="完成学时" prop="learn_duration">
          <el-select style="width:100%" v-model="form.learn_duration" placeholder="请选择">
            <el-option
              v-for="item in courses_total[form.course_id - 1]"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域" prop="area">
          <v-distpicker
            style="text-align: left"
            @selected="citySelected"
            :province="form.area"
            hide-area
            :city="form.economize"
          ></v-distpicker>
        </el-form-item>
        <el-form-item label="同步发布" prop="is_market" style="text-align: left">
          <el-select
            v-model="is_market"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVis = false">取 消</el-button>
        <el-button type="primary" @click="createPerson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      is_submit: true,
      searchValue: '',
      srelease: '',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE',
      },
      total: 20,
      current_page: 1,
      per_page: 10,
      tableData: [],
      dialogVis: false,
      operate: 'add',
      courses_total: [24, 16, 16], //初 中 高
      is_market: 1,
      form: {
        name: '',
        certificate: '',
        course_id: '',
        course_phase: '',
        learn_duration: '',
        card: '',
        course_total: 0, //总课时
        area: '甘肃省',
        economize: '兰州市',
        is_market: 1,
        is_achievement: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写姓名',
            trigger: 'blur',
          },
        ],
        certificate: [
          {
            required: true,
            message: '请填写证书编号',
            trigger: 'blur',
          },
        ],
        course_id: [
          {
            required: true,
            message: '请选择级别',
            trigger: 'change',
          },
        ],
        course_phase: [
          {
            required: true,
            message: '请填写培训期数',
            trigger: 'blur',
          },
        ],
        learn_duration: [
          {
            required: true,
            message: '请填写完成学时',
            trigger: 'change',
          },
        ],
        card: [
          {
            required: true,
            message: '请填写身份证号',
            trigger: 'blur',
          },
        ],
        area: [
          {
            required: true,
            message: '请选择所属区域',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    add() {
      this.dialogVis = true;
      this.operate = 'add';
      this.form.id = '';
      this.form.name = '';
      this.form.certificate = '';
      this.form.course_id = '';
      this.form.course_phase = '';
      this.form.learn_duration = '';
      this.form.card = '';
      this.form.area = '甘肃省';
      this.form.economize = '兰州市';
      this.form.is_market = 1;
      this.form.is_achievement = 1;
      this.is_market = 1;
    },
    courseIdChange(val) {
      this.form.course_total = this.courses_total[val - 1];
    },
    handleEdit(row) {
      this.operate = 'edit';
      this.dialogVis = true;
      this.form.id = row.id;
      this.form.name = row.name;
      this.form.certificate = row.certificate;
      this.form.course_id = row.courseId;
      this.form.course_phase = row.coursePhase;
      this.form.learn_duration = row.learnDuration;
      this.form.card = row.card;
      this.form.course_total = this.courses_total[row.courseId - 1];
      this.form.area = row.area;
      this.form.economize = row.economize;
      this.form.is_market = row.isMarket;
      this.form.is_achievement = row.isAchievement;
      this.is_market =
        row.isAchievement === 1 && row.isMarket === 1
          ? 1
          : row.isMarket === 1
          ? 2
          : 3;
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.http.request(`${urlConfig.devUrl}apij2/admin-api/voucher/skill-course-graduation/delete?id=` + row.id, '', 'delete').then(res => {
            if (res.code == 0) {
              this.ResetSearch(['searchValue']);
              this.getData('Technology_Skill_CGraduation');
              this.$message({
                type: 'success',
                message: '删除成功',
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    formmarket(val) {
      if (val === 1) {
        this.form.is_market = 1;
        this.form.is_achievement = 1;
      } else if (val === 2) {
        this.form.is_market = 1;
        this.form.is_achievement = 2;
      } else {
        this.form.is_market = 2;
        this.form.is_achievement = 1;
      }
    },
    //城市选择
    citySelected(e) {
      this.form.address = e;
      this.form.area = e.province.value;
      this.form.economize = e.city.value;
    },
    search() {
      this.getData(
        `/Technology_Skill_CGraduation?name=${this.searchValue}${
          (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
        }`
      );
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })

      }
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/voucher/skill-course-graduation/page`, params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.current_page = res.data.current_page;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    handleCurrentChange(val) {
      this.getData(`/Technology_Skill_CGraduation?page=${val}&name=${this.searchValue}${
        (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
      }`);
    },
    createPerson() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs['form'].validate(valid => {
        if (valid) {
          let obj = {
            name: this.form.name,
            courseId: this.form.course_id,
            coursePhase: this.form.course_phase,
            learnDuration: this.form.learn_duration,
            card: this.form.card,
            certificate: this.form.certificate,
            area: this.form.area,
            economize: this.form.economize,
            isMarket: this.form.is_market,
            isAchievement: this.form.is_achievement,
          };
          if (this.operate == 'add') {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/skill-course-graduation/create`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['searchValue']);
                  this.$message.success('新增成功');
                  this.is_market = 1;
                  this.dialogVis = false;
                  this.getData('Technology_Skill_CGraduation');
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            obj.id = this.form.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/voucher/skill-course-graduation/update`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['searchValue']);
                  this.$message.success('编辑成功');
                  this.is_market = 1;
                  this.dialogVis = false;
                  this.getData('Technology_Skill_CGraduation');
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },
  },
  mounted() {
    this.getData(`/Technology_Skill_CGraduation`);
  },
};
</script>

<style lang="scss">
@include component(business-person) {
  width: 100%;
  height: 100%;
  @include part(header) {
    display: flex;
    justify-content: flex-start;
    @include component(el-input) {
      width: 300px;
    }
    section {
      margin-left: 50px;
    }
  }
  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }
  @include part(addBtn) {
    margin-left: 30px;
  }
  @include part(table) {
    margin-top: 30px;
  }
}
</style>
